export const checkFileType = (file: File, allowedFileTypes: string[]) => {
    const isValid = !!allowedFileTypes.find((allowedType: string) => {
        if (allowedType.endsWith("*")) {
            const allowedTypes = allowedType.substring(
                0,
                allowedType.length - 1
            );
            return file.type.startsWith(allowedTypes);
        } else return allowedType === file.type;
    });
    return isValid;
};
